import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import LineString from './LineString';
import Geometry from './Geometry';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import CoordinateSequences from './CoordinateSequences';
import Dimension from './Dimension';
var LinearRing = /*#__PURE__*/function (_LineString) {
  _inherits(LinearRing, _LineString);
  function LinearRing() {
    var _this;
    _classCallCheck(this, LinearRing);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinearRing).call(this));
    LinearRing.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(LinearRing, [{
    key: "copyInternal",
    value: function copyInternal() {
      return new LinearRing(this._points.copy(), this._factory);
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return Dimension.FALSE;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      if (this.isEmpty()) return true;
      return _get(_getPrototypeOf(LinearRing.prototype), "isClosed", this).call(this);
    }
  }, {
    key: "reverseInternal",
    value: function reverseInternal() {
      var seq = this._points.copy();
      CoordinateSequences.reverse(seq);
      return this.getFactory().createLinearRing(seq);
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_LINEARRING;
    }
  }, {
    key: "validateConstruction",
    value: function validateConstruction() {
      if (!this.isEmpty() && !_get(_getPrototypeOf(LinearRing.prototype), "isClosed", this).call(this)) throw new IllegalArgumentException('Points of LinearRing do not form a closed linestring');
      if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < LinearRing.MINIMUM_VALID_SIZE) throw new IllegalArgumentException('Invalid number of points in LinearRing (found ' + this.getCoordinateSequence().size() + ' - must be 0 or >= 4)');
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_LINEARRING;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      var points = arguments[0],
        factory = arguments[1];
      LineString.constructor_.call(this, points, factory);
      this.validateConstruction();
    }
  }]);
  return LinearRing;
}(LineString);
export { LinearRing as default };
LinearRing.MINIMUM_VALID_SIZE = 4;